import img1 from '../resources/img1.jpg';
import img2 from '../resources/img2.jpg';
import img3 from '../resources/img3.jpg';
import img4 from '../resources/img4.jpg';
export var items=[
    {name:"Chloé; Absolu de Parfum",price:30,src:img1,desc:"Stardem burden hardem bratct de loui placiba",qty:0},
    {name:"Eau de Toilette Bloom of Rose",price:50,src:img2,desc:"Stardem burden hardem bratct de loui placiba",qty:0},
    {name:"YSL Opium Eau de Parfum",price:125,src:img3,desc:"Stardem burden hardem bratct de loui placiba",qty:0},
    {name:"Chanel; Coco Mademoiselle",price:75,src:img4,desc:"Stardem burden hardem bratct de loui placiba",qty:0},
]